module.exports = __webpack_public_path__ + "static/media/service5.793f6a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/images/service5.png
// module id = 439
// module chunks = 0